import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import { store } from './app/store';
import { Provider } from 'react-redux';
import LanguageProviderContainer from './features/A_ProviderContainer/container/container';

// Ab antd 5 gibt es keine LESS-Variablen mehr (frueher modifyVars in
// craco.config.js). Das Thema wird zur Laufzeit ueber Design-Token gesetzt;
// die Farben entsprechen den bisherigen Werten aus der craco-Konfiguration.
const animaTheme = {
  token: {
    colorPrimary: '#932b3f',
  },
  components: {
    Menu: {
      darkItemBg: '#32383e',
      darkSubMenuItemBg: '#000c17',
      darkItemSelectedBg: '#932b3f',
      itemColor: '#f8f9fa',
    },
  },
};

const container = document.getElementById('root');
if (!container) {
  throw new Error('Wurzelelement #root nicht gefunden.');
}

createRoot(container).render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider theme={animaTheme}>
        <LanguageProviderContainer id={'LanguageProviderBox'} />
      </ConfigProvider>
    </Provider>
  </React.StrictMode>,
);
